import { useEffect, useRef, useState } from "react";

export default function Cursor() {
  const ref = useRef(null);
  const [hover, setHover] = useState(false);
  const [label, setLabel] = useState("VIEW");

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tx = x, ty = y;
    let rafId;

    const move = (e) => { tx = e.clientX; ty = e.clientY; };
    const loop = () => {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      el.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      rafId = requestAnimationFrame(loop);
    };

    const onOver = (e) => {
      const t = e.target.closest("[data-cursor]");
      if (t) {
        setHover(true);
        setLabel(t.getAttribute("data-cursor") || "VIEW");
      } else {
        setHover(false);
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", onOver);
    rafId = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div ref={ref} className={`hd-cursor ${hover ? "is-hover" : ""}`} aria-hidden="true">
      <span className="lbl">{label}</span>
    </div>
  );
}
